import { useContext, useEffect } from 'react';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { Private_Routes } from '../../../main/constants';
import { AppContext } from '../../../main/context/Provider';
import { ProjectMilestoneForm } from '../components/form/ProjectMilestoneForm';

export const CreateProjectMilestonePage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);

    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Nuevo Hito ');

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Configuración de Hitos',
                route: Private_Routes.PROJECT_MILESTONE_PAGE,
            },
            {
                label: webPage,
                route: Private_Routes.CREATE_PROJECT_MILESTONE,
            },
        ]);
    }, [lang]);

    return <ProjectMilestoneForm isNewProjectMilestone={true} />;
};
